<div class="dashboard-header flex align-items-center mb-2">
  <i class="mr-2 pi pi-chart-line"></i>

  <span class="text-xl font-medium">Dashboard</span>

  <!-- Favoriten-Button -->
  <div
    jmlFavoriteButton
    [favoriteId]="'dashboard'"
    [favoriteName]="'Dashboard'"
    [favoriteIcon]="'pi pi-chart-line'"
    [favoriteRoute]="'/dashboard'"
  ></div>
</div>

<jml-lib-entity-view [layout]="layout" [entryId]="dashboardId" configName="Dashboard"></jml-lib-entity-view>
